"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

require("./ButtonGroup.scss");

var _excluded = ["loose", "fluid", "isFluid", "align", "vertical", "size", "skin", "shape", "variant", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** Sets the variant to all buttons in the button group  */
  variant: (0, _propTypes.oneOf)(['filled', 'outline', 'flat']),

  /** Sets the skin to all buttons in the button group */
  skin: (0, _propTypes.oneOf)(['dark', 'light', 'success', 'danger', 'info']),

  /** Sets the size to all buttons in the button group */
  size: (0, _propTypes.oneOf)(['small', 'medium', 'large']),

  /** Sets the shape to all buttons in the button group */
  shape: (0, _propTypes.oneOf)(['rounded', 'pill']),

  /** Add spacing between the buttons */
  loose: _propTypes.bool,

  /** Align button group to the start, center or end of the current flexbox context  */
  align: (0, _propTypes.oneOf)(['start', 'center', 'end']),

  /** Stack the buttons on top of each other  */
  vertical: _propTypes.bool,

  /** @deprecated Use `isFluid` instead */
  fluid: _propTypes.bool,

  /** Makes the button group fill the parents available space */
  isFluid: _propTypes.bool,

  /** Add your own custom class names to the component */
  className: _propTypes.string,

  /** The buttons inside the group */
  children: _propTypes.node
};
var defaultProps = {
  size: 'medium',
  variant: 'filled',
  shape: 'rounded',
  align: 'start'
};
/** Used to group Button components.
 * @visibleName Button Group
 * */

var ButtonGroup = function ButtonGroup(_ref) {
  var loose = _ref.loose,
      fluid = _ref.fluid,
      isFluid = _ref.isFluid,
      align = _ref.align,
      vertical = _ref.vertical,
      size = _ref.size,
      skin = _ref.skin,
      shape = _ref.shape,
      variant = _ref.variant,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = (0, _classnames.default)('rds-btn-group', {
    'rds-btn-group--loose': loose,
    'rds-is-fluid': fluid || isFluid,
    'rds-btn-group--start': align === 'start' || align === '' || align === null,
    'rds-btn-group--center': align === 'center',
    'rds-btn-group--end': align === 'end',
    'rds-btn-group--vertical': vertical
  }, className);

  var childrenWithProps = _react.default.Children.map(children, function (child) {
    var childProps;
    var childSkin = child.props.skin;
    var childType = child.props.variant;
    var childShape = child.props.shape; // NO SKIN, NO TYPE, NO SHAPE

    if ((childSkin === '' || !childSkin) && (childType === '' || !childType) && (childShape === '' || !childShape)) {
      childProps = {
        size: size,
        skin: skin,
        variant: variant,
        shape: shape
      };
    } // WITH SKIN, NO TYPE, NO SHAPE
    else if ((childSkin !== '' || childSkin) && (childType === '' || !childType) && (childShape === '' || !childShape)) {
        childProps = {
          size: size,
          variant: variant,
          shape: shape
        };
      } // NO SKIN, WITH TYPE, NO SHAPE
      else if ((childSkin === '' || !childSkin) && (childType !== '' || childType) && (childShape === '' || !childShape)) {
          childProps = {
            size: size,
            skin: skin,
            shape: shape
          };
        } // NO SKIN, NO TYPE, WITH SHAPE
        else if ((childSkin === '' || !childSkin) && (childType === '' || !childType) && (childShape !== '' || childShape)) {
            childProps = {
              size: size,
              skin: skin,
              variant: variant
            };
          } // WITH SKIN, WITH TYPE, NO SHAPE
          else if ((childSkin !== '' || childSkin) && (childType !== '' || childType) && (childShape === '' || !childShape)) {
              childProps = {
                size: size,
                shape: shape
              };
            } // NO SKIN, WITH TYPE, WITH SHAPE
            else if ((childSkin === '' || !childSkin) && (childType !== '' || childType) && (childShape !== '' || childShape)) {
                childProps = {
                  size: size,
                  skin: skin
                };
              } // WITH SKIN, NO TYPE, WITH SHAPE
              else if ((childSkin !== '' || childSkin) && (childType === '' || !childType) && (childShape !== '' || childShape)) {
                  childProps = {
                    size: size,
                    variant: variant
                  };
                } // WITH SKIN, WITH TYPE, WITH SHAPE
                else if ((childSkin !== '' || childSkin) && (childType !== '' || childType) && (childSkin !== '' || childSkin)) {
                    childProps = {
                      size: size
                    };
                  }

    return /*#__PURE__*/_react.default.cloneElement(child, childProps);
  });

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: componentClassNames,
    role: "group"
  }, rest), childrenWithProps);
};

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;
var _default = ButtonGroup;
exports.default = _default;